(function ($) {
  document.addEventListener('DOMContentLoaded', function () {
    if (document.querySelector(".banner__timer-wrapper")) {
      var getTimeRemaining = function getTimeRemaining(endtime) {
        var t = Date.parse(endtime) - Date.parse(new Date());
        var seconds = Math.floor(t / 1000 % 60);
        var minutes = Math.floor(t / 1000 / 60 % 60);
        var hours = Math.floor(t / (1000 * 60 * 60) % 24);
        var days = Math.floor(t / (1000 * 60 * 60 * 24));
        return {
          total: t,
          days: days,
          hours: hours,
          minutes: minutes,
          seconds: seconds
        };
      };

      var initializeClock = function initializeClock(id, endtime) {
        var clock = document.getElementById(id);
        var daysSpan = clock.querySelector(".days");
        var hoursSpan = clock.querySelector(".hours");
        var minutesSpan = clock.querySelector(".minutes");
        var secondsSpan = clock.querySelector(".seconds");

        function updateClock() {
          var t = getTimeRemaining(endtime);

          if (t.total <= 0) {
            document.getElementById("countdown").className = "hidden";
            document.getElementById("deadline-message").className = "visible";
            clearInterval(timeinterval);
            return true;
          }

          daysSpan.innerHTML = t.days;
          hoursSpan.innerHTML = ("0" + t.hours).slice(-2);
          minutesSpan.innerHTML = ("0" + t.minutes).slice(-2);
          secondsSpan.innerHTML = ("0" + t.seconds).slice(-2);
        }

        updateClock();
        var timeinterval = setInterval(updateClock, 1000);
      };

      var currentDate = new Date();
      var time = +document.getElementById("countdown").dataset.time_start - Date.parse(currentDate.toUTCString()) / 1000,
          deadline = new Date(Date.parse(new Date()) + time * 1000); // for endless timer

      initializeClock("countdown", deadline);
    }
  });
})(jQuery);